"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Facebook, Linkedin, Twitter, Instagram } from "lucide-react";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <nav className="flex gap-6">
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
      </nav>;
  }
  return <nav className="flex gap-6 flex-wrap justify-center">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm font-sans uppercase tracking-wide text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Stopka() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer id="stopka" className="bg-background text-foreground py-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {}
          <div className="text-center md:text-left space-y-2">
            <p className="text-sm text-muted-foreground font-sans">
              © {currentYear} Odszkodowania Słupsk. Wszelkie prawa zastrzeżone.
            </p>
            
          </div>

          {}
          <div className="flex justify-center">
            <MenuProvider menu_id="29" className="footer-navigation">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          
        </div>
      </div>
    </footer>;
}